/**
 * iter917 — Master Tailor: bilingual (EN/AR) receipt section built from
 * order `metadata` (pos_orders doc). Renderer-agnostic: returns a title +
 * label/value rows that nativeThermalPrint (DantSu), eposPrint (XML) and
 * the browser print-dialog HTML all consume.
 */
export const TAILOR_LABELS = {
  section: 'MEASUREMENTS / القياسات',
  modification: 'MODIFICATION / تعديل فقط',
  customer: 'Customer / العميل',
  phone: 'Phone / الجوال',
  ready: 'Ready Date / تاريخ التسليم',
  notes: 'Notes / ملاحظات',
  fields: {
    length: 'Length / الطول',
    shoulder: 'Shoulder / الكتف',
    chest: 'Chest / الصدر',
    sleeve: 'Sleeve / الكم',
    neck: 'Neck / الرقبة',
    waist: 'Waist / الخصر',
  },
};

export function tailorReceiptLines(metadata) {
  if (!metadata) return null;
  const m = metadata;
  const meas = m.measurements || {};
  const hasMeas = Object.keys(meas).some((k) => meas[k] !== '' && meas[k] != null);
  if (!hasMeas && !m.modification_only && !m.customer_name && !m.ready_date) return null;
  const rows = [];
  if (m.customer_name) rows.push({ label: TAILOR_LABELS.customer, value: String(m.customer_name) });
  if (m.customer_phone) rows.push({ label: TAILOR_LABELS.phone, value: String(m.customer_phone) });
  if (m.ready_date) rows.push({ label: TAILOR_LABELS.ready, value: String(m.ready_date) });
  if (m.modification_only) {
    if (m.modification_notes) rows.push({ label: TAILOR_LABELS.notes, value: String(m.modification_notes) });
  } else {
    Object.entries(TAILOR_LABELS.fields).forEach(([k, label]) => {
      if (meas[k] !== '' && meas[k] != null) rows.push({ label, value: String(meas[k]) });
    });
  }
  if (!rows.length) return null;
  return { title: m.modification_only ? TAILOR_LABELS.modification : TAILOR_LABELS.section, rows };
}
